import axios from "axios";
import decode from 'jwt-decode';
import { useEffect, useState } from "react";
import AdminHeader from "./AdminHeader";

import Pagination from "./Pagination";
import { useTranslation } from "react-i18next";
import { redirect, useNavigate } from "react-router-dom";

import '../../styles/admin.scss';
import RAGroupApplications from "./RAGroupApplications";
import WaveApplications from "./WaveApplications";

const today = new Date(new Date().setUTCHours(0,0,0,0));
const oneDay = (1000 * 60 * 60 * 24);
const rangeInitials = {start: new Date(today.valueOf() - (6 * oneDay)), end: today, group: 'lastWeek'};



const Admin = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [applications, setApplications] = useState([]);
    const [totalApplications, setTotalApplications] = useState(0);
    const [profile, setProfile] = useState(null);
    const [tableRange, setTableRange] = useState(rangeInitials);
    // const [page, setPage] = useState(pg ? pg : 1);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const [company, setCompany] = useState('ragroup');

    async function fetchData(page, start, end) {
        const resData = await axios.get(`https://server.ragroup.org/${company}?page=${page}&start=${start}&end=${end}`);
        const {applications, page:pg, totalPages: tp, limit, count} = resData.data;
        setApplications(applications);
        if(page !== pg)
            setPage(pg);
        setTotalPages(tp);
        setTotalApplications(count);
    }

    useEffect(()=>{
        fetchData(page, tableRange.start, tableRange.end);
    }, [tableRange, page, company]);

    useEffect(() => {
        if(profile && profile.user && profile.token){
            const token = profile.token;
            if (token) {
                const decodedToken = decode(token);
          
                if (decodedToken.exp * 1000 <= new Date().getTime()){
                    localStorage.removeItem('profile');  
                }
            }
        }else{
            if (typeof window !== "undefined") {
                const user = JSON.parse(localStorage.getItem('profile'));
                if(user)
                    setProfile(user);
                else
                    navigate('/admin/login')
            }else
                navigate('/admin/login')
        }
    }, [profile]);

    function numMonthToString(num) {
        switch (Number(num)) {
            case 1:
                return t("month.january"); 
            case 2:
                return t("month.february"); 
            case 3:
                return t("month.march"); 
            case 4:
                return t("month.april"); 
            case 5:
                return t("month.may"); 
            case 6:
                return t("month.june"); 
            case 7:
                return t("month.july"); 
            case 8:
                return t("month.august"); 
            case 9:
                return t("month.september"); 
            case 10:
                return t("month.october"); 
            case 11:
                return t("month.november"); 
            case 12:
                return t("month.december"); 
            default:
                return null;
        }
    }

    function dateFormat(data) {
        console.log(data)
        const dateString = new Date(data).toLocaleString(undefined, {timeZone: 'Asia/Almaty' });
        return dateString
        // console.log(dateString)
        // let date = (dateString.split("T")[0]).split("-");
        // let time = ((dateString.split("T")[1]).split(".")[0]).split(":");

        // let year = date[0];
        // let month = date[1];
        // let day = Number(date[2]);

        // return date + " " + time;
        // return `${time[0]}:${time[1]} ${day} ${numMonthToString(month).toLowerCase()} ${year}`;
    }

    function printRange() {
        var start = tableRange.start.getFullYear() === tableRange.end.getFullYear() ? 
            `${numMonthToString(tableRange.start.getMonth()+1)} ${tableRange.start.getDate()}`
            :  
            `${numMonthToString(tableRange.start.getMonth()+1)} ${tableRange.start.getDate()}, ${tableRange.start.getFullYear()}`;
        var end = `${numMonthToString(tableRange.end.getMonth()+1)} ${tableRange.end.getDate()}, ${tableRange.end.getFullYear()}`;
        var group = t(`admin.table.filter.${tableRange.group}`);
        return start + " - " + end + " " + group;
    }
    const changeTableRange = (e) => {
        const value = e.currentTarget.dataset.range;
        let range = rangeInitials;
        const tmpStart = new Date(today.valueOf());
        switch (value) {
            case 'lastWeek':
                range.start = new Date(tmpStart.valueOf() - (6*oneDay));
                range.group = 'lastWeek';
                break;
            case 'lastMonth': 
                range.start = new Date(tmpStart.setMonth(tmpStart.getMonth()-1));
                range.group = 'lastMonth';
                break;
            case 'lastHalfYear': 
                range.start = new Date(tmpStart.setMonth(tmpStart.getMonth()-6));
                range.group = 'lastHalfYear';
                break;
            case 'lastYear': 
                range.start = new Date(tmpStart.setMonth(tmpStart.getMonth()-12));
                range.group = 'lastYear';
                break;
        }
        // console.log(range);
        setTableRange({...tableRange, start: range.start, group: range.group});
        setPage(1);
    }

    return (
        <>
            <AdminHeader company={company} setCompany={setCompany}/>
            <div id="admin">
                <div className="content">
                    <div className="semibold-32-48">{t("admin.table.header")} - {company === 'ragroup' ? 'RA Group' : 'Wave'}</div>
                    <div className='filter'>
                        <div className='regular-16-20'>
                            {t("admin.table.applications.count", {count: totalApplications})}
                        </div>
                        <div className='dropdown'>
                            <button className='dropbtn regular-16-20'>{printRange()} <i></i></button>
                            <ul className='dropcontent'>
                                <li onMouseDown={changeTableRange} data-range="lastWeek">
                                    {t("admin.table.filter.lastWeek")}
                                </li>
                                <li onMouseDown={changeTableRange} data-range="lastMonth">
                                    {t("admin.table.filter.lastMonth")}
                                </li>
                                <li onMouseDown={changeTableRange} data-range="lastHalfYear">
                                    {t("admin.table.filter.lastHalfYear")}
                                </li>
                                <li onMouseDown={changeTableRange} data-range="lastYear">
                                    {t("admin.table.filter.lastYear")}
                                </li>
                            </ul>
                        </div>
                    </div>
                    {company === 'ragroup' && (
                        <RAGroupApplications t={t} applications={applications} dateFormat={dateFormat} />
                    )}
                    {company === 'wave' && (
                        <WaveApplications t={t} applications={applications} dateFormat={dateFormat} />
                    )}
                    <Pagination page={page} totalPages={totalPages} setPage={setPage} />
                </div>
            </div>
        </>
    );
};

export default Admin;